import Swiper from "swiper/bundle";
import {
  $WINDOW,
  L_MOBILE_WIDTH,
  L_TABLET_WIDTH,
  SHOW_CLASS,
  TABLET_WIDTH,
} from "../lib/constants";

export const swiperFunctions = () => {
  const ACTIVE_SLIDER_CLASS = "active-slide";
  const $readMoreSection = $(".js-read-more");
  const $slides = $readMoreSection.find(".swiper-slide");

  const toggleBoilerThumbsSlider = () => {
    if ($WINDOW.width() < L_TABLET_WIDTH) {
      boilerThumbs.disable();
    }
  };

  const toggleShowSlidesFromReadMoreSection = () => {
    $.each($slides, function (i, el) {
      const $slide = $(el);

      if (
        ($WINDOW.width() > L_MOBILE_WIDTH &&
          $WINDOW.width() < TABLET_WIDTH &&
          i > 3) ||
        ($WINDOW.width() <= L_MOBILE_WIDTH && i > 2)
      ) {
        $slide.hide();
      } else {
        $slide.show();
      }
    });
  };

  const mainSlider = new Swiper(".js-main-slider-swiper", {
    spaceBetween: 2,
    speed: 1400,
    autoplay: {
      delay: 4200,
    },
    loop: true,
    slidesPerView: 1,
    pagination: {
      el: ".js-swiper-pagination",
      clickable: true,
    },
    navigation: {
      prevEl: ".js-main-slider-btn-prev",
      nextEl: ".js-main-slider-btn-next",
    },
  });

  if (mainSlider.slides.length > 1) {
    $(".js-main-slider-nav-btns").addClass(SHOW_CLASS);
  }

  const press = new Swiper(".js-press-swiper", {
    slidesPerView: 1.1,
    spaceBetween: 8,
    autoHeight: true,
    breakpoints: {
      641: {
        slidesPerView: 2,
        spaceBetween: 20,
        autoHeight: true,
      },
      1025: {
        slidesPerView: 3,
        spaceBetween: 20,
        autoHeight: true,
      },
    },
    // slideActiveClass: ACTIVE_SLIDER_CLASS,
    pagination: {
      el: ".js-swiper-pagination",
      // dynamicBullets: true,
      clickable: true,
    },
  });

  const boilerThumbs = new Swiper(".js-boiler-sls-thumbs", {
    spaceBetween: 8,
    slidesPerView: 7.4,
  });

  const boilerPreview = new Swiper(".js-boiler-sls-preview", {
    pagination: {
      el: ".js-boiler-sls-preview-pagination",
      // dynamicBullets: true,
      clickable: true,
    },
    navigation: {
      prevEl: ".js-boiler-sls-thumbs-btn-prev",
      nextEl: ".js-boiler-sls-thumbs-btn-next",
    },
    thumbs: {
      swiper: boilerThumbs,
    },
  });

  const bonusImgs = new Swiper(".js-bonus-imgs-slider", {
    loop: true,
    pagination: {
      el: ".js-bonus-imgs-slider-pagination",
      // dynamicBullets: true,
      clickable: true,
    },
    navigation: {
      prevEl: ".js-bonus-imgs-slider-btn-prev",
      nextEl: ".js-bonus-imgs-slider-btn-next",
    },
  });

  const fixChangeHeaderSliderThumbs = () => {
    const $THUMBS = $(".js-boiler-sls-thumbs-slide");

    $THUMBS.on("click", function () {
      const $t = $(this);

      if (!$t.hasClass(ACTIVE_SLIDER_CLASS)) {
        $.each($THUMBS, (i, el) => {
          if (this === el) {
            boilerThumbs.slideTo(i);
            boilerThumbs.allowSlideNext = true;

            boilerPreview.slideTo(i);
            boilerPreview.allowSlideNext = true;

            $THUMBS.removeClass(ACTIVE_SLIDER_CLASS);
            $t.addClass(ACTIVE_SLIDER_CLASS);
          }
        });
      }
    });
  };

  toggleBoilerThumbsSlider();
  fixChangeHeaderSliderThumbs();
  toggleShowSlidesFromReadMoreSection();

  const isPressSwiperInReadMoreSection =
    $(".js-press-swiper").parents(".js-read-more:last").length;

  if (isPressSwiperInReadMoreSection && $WINDOW.width() < TABLET_WIDTH) {
    press.disable();
  }

  $WINDOW.on("resize", () => {
    if (isPressSwiperInReadMoreSection && $WINDOW.width() < TABLET_WIDTH) {
      press.disable();
    } else {
      if (isPressSwiperInReadMoreSection) {
        press.enable();
      }
    }

    toggleShowSlidesFromReadMoreSection();
  });
};
